module.exports = __webpack_public_path__ + "static/media/logo.835affc9.svg";